import type { IconName } from '@hotjar/hotsauce';
import { QuestionTypes } from '@hotjar/feedback/domain/Surveys/Questions';

export function getQuestionLabelAndIcon(questionType: QuestionTypes): {
  icon: IconName;
  label: string;
} {
  switch (questionType) {
    case QuestionTypes.EMAIL:
      return { icon: 'email', label: 'email' };
    case QuestionTypes.SINGLE_OPEN_ENDED_SINGLE_LINE:
      return { icon: 'text_field_short', label: 'short-text' };
    case QuestionTypes.SINGLE_OPEN_ENDED_MULTI_LINE:
      return { icon: 'text_field_tall', label: 'long-text' };
    case QuestionTypes.TITLE_AND_DESCRIPTION:
      return { icon: 'text', label: 'statement' };
    case QuestionTypes.MULTIPLE_CLOSE_ENDED:
      return { icon: 'checkbox', label: 'checkbox' };
    case QuestionTypes.SINGLE_CLOSE_ENDED:
      return { icon: 'radio_button', label: 'radio' };
    case QuestionTypes.RATING_SCALE_5:
      return { icon: 'rating_scale', label: 'rating-5' };
    case QuestionTypes.RATING_SCALE_7:
      return { icon: 'rating_scale', label: 'rating-7' };
    case QuestionTypes.NET_PROMOTER_SCORE:
      return { icon: 'nps', label: 'nps' };
    case QuestionTypes.REACTION:
      return { icon: 'like', label: 'reaction' };
  }
}
